module.exports = new __parcel__URL__("image_zh-cn.cf5f0a9f.png").toString();